import dayjs, { type Dayjs } from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";

dayjs.extend(isSameOrBefore);
dayjs.extend(isToday);

export const isWeekend = (date: Dayjs | string) => {
  const day = typeof date !== "string" ? dayjs(date.toDate()).day() : dayjs(date).day();
  return day === 0 || day === 6;
};

export const isPastDate = (date: Dayjs | string) => {
  const selectedDate = typeof date !== "string" ? dayjs(date.toDate()) : dayjs(date);
  const today = dayjs().startOf("day");
  return selectedDate.isBefore(today);
};

export const isValidScheduledDate = (date: string) => {
  if (!date) {
    return true;
  }

  const selectedDate = dayjs(date);
  if (!selectedDate.isValid()) {
    return false;
  }

  return !isPastDate(selectedDate) && !isWeekend(selectedDate);
};

export const getDateValidationError = (date: string): string | null => {
  if (!date) {
    return null;
  }

  const selectedDate = dayjs(date);
  if (!selectedDate.isValid()) {
    return "Invalid date";
  }

  if (isPastDate(selectedDate)) {
    return "Past dates are not allowed";
  }

  if (isWeekend(selectedDate)) {
    return "Weekends are not selectable";
  }

  return null;
};

export const useDateValidation = () => {
  const checkDateIsValid = (date: string) => {
    if (date) {
      const formattedDate = dayjs(date);
      const today = dayjs().startOf("day");
      const shouldDisable = formattedDate.isBefore(today) || isWeekend(formattedDate);
      return shouldDisable;
    }
    return false;
  };

  return { checkDateIsValid };
};

export const getNextWeekdayDate = () => {
  const today = dayjs();

  // If today is a weekday, return today
  if (!isWeekend(today)) {
    return today.format("YYYY-MM-DD");
  }

  // If today is Saturday (day 6), add 2 days to get Monday
  // If today is Sunday (day 0), add 1 day to get Monday
  const daysToAdd = today.day() === 6 ? 2 : 1;
  return today.add(daysToAdd, "day").format("YYYY-MM-DD");
};
